import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import PredefinedDateRanges from "../../../core/common/datePicker";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import Table from "../../../core/common/dataTable/index";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import CommonSelect from "../../../core/common/commonSelect";
import DeleteModal from "../../../core/modals/deleteModal";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import Loader from "../../../core/common/loader";
import { showBasicAlert } from "../../../core/common/useAlert";
import { company_short_name } from "../../../environment";
import api from "../../../services/api";
declare module "jspdf-autotable";
type PasswordField = "password" | "confirmPassword";

const Companies = () => {
  const signature = localStorage.getItem("signature");
  const [companyData, setcompanyData] = useState<any | undefined>(undefined);
  const [planName, setPlanName] = useState<any | undefined>(undefined); //Show  only plans which is buy by any company once, not all packages

  //Exort Data Handle function Start
  const handleExportPDF = () => {
    const doc = new jsPDF();

    // Example columns
    const columns = ["ID", "Company Name", "Email", "Plan", "Date", "Status"];
    const tableData: (string | number)[][] = filteredData.map((item) => [
      item.key, // Assuming the first element is a number (ID)
      item.CompanyName, // Assuming the second element is a string (Company name)
      item.Email, // Email (string)
      item.Plan, // Plan (string)
      item.CreatedDate, // Date (string)
      item.Status, // Status (string)
    ]);
    // Generate the table in the PDF (no need to pass `doc` as the first argument anymore)
    doc.autoTable({
      head: [columns],
      body: tableData,
    });

    // Save the PDF
    doc.save("companies-list.pdf");
  };
  const handleExportExcel = () => {
    const ws = XLSX.utils.json_to_sheet(filteredData); // Convert JSON to sheet
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    XLSX.writeFile(wb, "companies-list.xlsx");
  };
  //Exort Data Handle function End

  //Filter and Function Start
  const [statusFilter, setStatusFilter] = useState<string | null>(null);
  const [planFilter, setPlanFilter] = useState<string | null>(null);
  const [sortBy, setSortBy] = useState<string>("Last 7 Days");
  const [selectedStartDate, setSelectedStartDate] =
    useState<moment.Moment | null>(null);
  const [selectedEndDate, setSelectedEndDate] = useState<moment.Moment | null>(
    null
  );
  const handleDateChange = (start: moment.Moment, end: moment.Moment) => {
    setSelectedStartDate(start);
    setSelectedEndDate(end);
  };
  const handleReset = () => {
    setFilteredData(data);
  };

  //Filter and Function End

  const [data, setData] = useState<any[]>([]);
  const [filteredData, setFilteredData] = useState(data);

  //Country Data and Function Start
  const [CountryCode, setCountryCode] = useState<any[]>([]);
  const handleCountryCodeChange = (e: any) => {
    const country_code = e.target.value;
    setFormData((prevData) => ({
      ...prevData,
      countryCode: country_code,
    }));
  };

  const [countries, setCountries] = useState<any[]>([]);

  const [statesOrignal, setStatesOrignal] = useState<any[]>([]);
  const [states, setStates] = useState<any[]>([]);

  const [citiesOrignal, setCitiesOrignal] = useState<any[]>([]);
  const [cities, setCities] = useState<any[]>([]);

  const [isLoading, setIsLoading] = useState(false); // state to track loading

  const handleCountryChange = (e: any) => {
    const countryId = e.target.value;
    setFormData((prevData) => ({
      ...prevData,
      country: countryId,
      state: "", // Reset state
      city: "", // Reset city
    }));
    // Filter states based on country selection
    const filteredStates = statesOrignal.filter(
      (state) => state.country_id == countryId
    );
    setStates(filteredStates);
  };

  const handleStateChange = (e: any) => {
    const stateId = e.target.value;
    // Filter cities based on state selection
    setFormData((prevData) => ({
      ...prevData,
      state: stateId,
      city: "", // Reset city when state changes
    }));

    const filteredCities = citiesOrignal.filter(
      (city) => city.state_id == stateId
    );
    setCities(filteredCities);
  };

  const handleCityChange = (e: any) => {
    const cityId = e.target.value;
    // Filter cities based on state selection
    setFormData((prevData) => ({
      ...prevData,
      city: cityId, // Reset city when state changes
    }));
  };

  //Country Data and Function End

  const [plan, setPlan] = useState<any[]>([]);

  //View Data Of Company
  const [selectedCompany, setSelectedCompany] = useState<any | null>(null);
  // Handle the row selection for the "eye" icon click
  const handleCompanyDetail = (record: any) => {
    try {
      var country_id = record.Country;
      var state_id = record.State;
      var city_id = record.City;

      const countryDetail = countries.filter(
        (item) => item.id === parseInt(country_id)
      );
      var countryName = countryDetail[0].name;
      var countryCurrency = countryDetail[0].currency_symbol;

      const stateDetail = statesOrignal.filter(
        (state) => parseInt(state.id) == parseInt(state_id)
      );
      var stateName = stateDetail[0].name;

      const CityDetail = citiesOrignal.filter(
        (city) => parseInt(city.id) == parseInt(city_id)
      );
      var cityName = CityDetail[0].name;

      var Address =
        record.Address1 +
        "," +
        record.Address2 +
        "," +
        cityName +
        "," +
        stateName +
        "," +
        countryName +
        "," +
        record.Pincode;
      record.Address = Address;
      record.countryCurrency = countryCurrency;
      setSelectedCompany(record);
    } catch (e) {
      console.log(e);
    }
  };

  //View Data Of Company
  const [selectedCompanyEdit, setSelectedCompanyEdit] = useState<any | null>(
    null
  );
  // Handle the row selection for the "eye" icon click
  const handleCompanyEdit = (record: any) => {
    try {
      var country_id = record.Country;
      var state_id = record.State;
      var city_id = record.City;

      const countryDetail = countries.filter(
        (item) => item.id === parseInt(country_id)
      );
      var countryName = countryDetail[0].name;
      var countryCurrency = countryDetail[0].currency_symbol;

      const stateDetail = statesOrignal.filter(
        (state) => parseInt(state.id) == parseInt(state_id)
      );
      var stateName = stateDetail[0].name;

      const CityDetail = citiesOrignal.filter(
        (city) => parseInt(city.id) == parseInt(city_id)
      );
      var cityName = CityDetail[0].name;

      var Address =
        record.Address1 +
        "," +
        record.Address2 +
        "," +
        cityName +
        "," +
        stateName +
        "," +
        countryName +
        "," +
        record.Pincode;
      record.Address = Address;
      record.countryCurrency = countryCurrency;
      setSelectedCompanyEdit(record);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    // This will run when the component mounts
    const fetchDashboardData = async () => {
      try {
        setIsLoading(true);
        // Making all requests in parallel
        const [
          companiesResponse,
          countryResponse,
          stateResponse,
          planResponse,
          cityResponse,
        ] = await Promise.all([
          api.post("userService/getCompaniesData", { signature }),
          api.post("userService/getCountry", { signature }),
          api.post("userService/getState", { signature }),
          api.post("userService/getPlan", { signature }),
          api.post("userService/getCity", { signature }),
        ]);

        // Setting the states after all data is fetched
        setFilteredData(companiesResponse.data.data.data);
        setData(companiesResponse.data.data.data);
        setcompanyData(companiesResponse.data.data);
        setPlanName(companiesResponse.data.data.package_details);

        setCountryCode(countryResponse.data.data);
        setCountries(countryResponse.data.data);

        setStatesOrignal(stateResponse.data.data);

        setPlan(planResponse.data.data);

        setCitiesOrignal(cityResponse?.data?.data);
        setIsLoading(false);
      } catch (err) {
        console.error("Error fetching dashboard data:", err);
      }
    };

    fetchDashboardData();
  }, []);

  useEffect(() => {
    if (filteredData) {
      var newFilteredData = data
        .filter((item: any) => {
          if (
            statusFilter &&
            item.Status.toLowerCase() !== statusFilter.toLowerCase()
          ) {
            return false;
          }
          if (planFilter && item.Plan !== planFilter) {
            return false;
          }
          // Apply date range filter (if dates are selected)
          if (selectedStartDate && selectedEndDate) {
            const createdDate = new Date(item.CreatedDate);

            // Convert moment objects to Date objects if needed
            const startDate =
              selectedStartDate instanceof Date
                ? selectedStartDate
                : selectedStartDate.toDate();
            const endDate =
              selectedEndDate instanceof Date
                ? selectedEndDate
                : selectedEndDate.toDate();

            // Check if the created date is within the selected date range
            if (createdDate < startDate || createdDate > endDate) {
              return false;
            }
          }
          return true;
        })
        .sort((a: any, b: any) => {
          switch (sortBy) {
            case "Recently Added":
              return (
                new Date(b.CreatedDate).getTime() -
                new Date(a.CreatedDate).getTime()
              );
            case "Ascending":
              return a.CompanyName.localeCompare(b.CompanyName);
            case "Descending":
              return b.CompanyName.localeCompare(a.CompanyName);
            case "Last Month":
              const oneMonthAgo = new Date();
              oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1); // Get the date for one month ago
              const lastMonthCreatedDate =
                new Date(b.CreatedDate).getTime() -
                new Date(a.CreatedDate).getTime();

              // If the created date is within the last month, continue sorting by CreatedDate
              if (
                new Date(b.CreatedDate) >= oneMonthAgo &&
                new Date(a.CreatedDate) >= oneMonthAgo
              ) {
                return lastMonthCreatedDate;
              } else {
                return 0; // Do not change order if dates are not within the last month
              }
            case "Last 7 Days":
              const sevenDaysAgo = new Date();
              sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7); // Get the date for 7 days ago
              const last7DaysCreatedDate =
                new Date(b.CreatedDate).getTime() -
                new Date(a.CreatedDate).getTime();

              // If the created date is within the last 7 days, continue sorting by CreatedDate
              if (
                new Date(b.CreatedDate) >= sevenDaysAgo &&
                new Date(a.CreatedDate) >= sevenDaysAgo
              ) {
                return last7DaysCreatedDate;
              } else {
                return 0; // Do not change order if dates are not within the last 7 days
              }

            default: // 'Last 7 Days'
              return (
                new Date(b.CreatedDate).getTime() -
                new Date(a.CreatedDate).getTime()
              ); // Adjust logic for 'Last 7 Days'
          }
        });
      var dateFilter = [...newFilteredData];
      if (dateFilter.length > 0) {
        setFilteredData(dateFilter); // Update filtered data
      } else {
        if (data.length > 0) {
          showBasicAlert("No Data");
        }
      }
    }
  }, [statusFilter, planFilter, sortBy, selectedStartDate, selectedEndDate]);

  const columns = [
    {
      title: "Company Name",
      dataIndex: "CompanyName",
      render: (text: String, record: any) => (
        <div className="d-flex align-items-center file-name-icon">
          <Link to="#" className="avatar avatar-md border rounded-circle">
            <ImageWithBasePath
              src={`${record.Image || "assets/img/users/user-01.jpg"}`}
              className="img-fluid"
              alt="img"
            />
          </Link>
          <div className="ms-2">
            <h6 className="fw-medium">
              <Link to="#">{record.CompanyName}</Link>
            </h6>
          </div>
        </div>
      ),
      sorter: (a: any, b: any) => a.CompanyName.length - b.CompanyName.length,
    },
    {
      title: "Email",
      dataIndex: "Email",
      sorter: (a: any, b: any) => a.Email.length - b.Email.length,
    },
    {
      title: "Plan",
      dataIndex: "Plan",
      render: (text: String, record: any) => (
        <div className="d-flex align-items-center justify-content-between">
          <p className="mb-0 me-2">{record.Plan}</p>
          <Link
            to="#"
            data-bs-toggle="modal"
            className="badge badge-purple badge-xs"
            data-bs-target="#upgrade_info"
            onClick={() => handleCompanyDetail(record)}
          >
            Upgrade
          </Link>
        </div>
      ),
      sorter: (a: any, b: any) => a.Plan.length - b.Plan.length,
    },
    {
      title: "Created Date",
      dataIndex: "CreatedDate",
      sorter: (a: any, b: any) => a.CreatedDate.length - b.CreatedDate.length,
    },
    {
      title: "Status",
      dataIndex: "Status",
      render: (text: string, record: any) => (
        <span
          className={`badge ${
            text === "Active" ? "badge-success" : "badge-danger"
          } d-inline-flex align-items-center badge-xs`}
        >
          <i className="ti ti-point-filled me-1" />
          {text}
        </span>
      ),
      sorter: (a: any, b: any) => a.Status.length - b.Status.length,
    },
    {
      title: "",
      dataIndex: "actions",
      render: (text: String, record: any) => (
        <div className="action-icon d-inline-flex">
          <Link
            to="#"
            className="me-2"
            data-bs-toggle="modal"
            data-bs-target="#company_detail"
            onClick={() => handleCompanyDetail(record)} // Set the selected company data
          >
            <i className="ti ti-eye" />
          </Link>
          <Link
            to="#"
            className="me-2"
            data-bs-toggle="modal"
            data-bs-target="#edit_company"
            onClick={() => handleCompanyEdit(record)}
          >
            <i className="ti ti-edit" />
          </Link>
          <Link
            to="#"
            data-bs-toggle="modal"
            data-bs-target="#delete_modal"
            onClick={() => setDeleteRecord(record)}
          >
            <i className="ti ti-trash" />
          </Link>
        </div>
      ),
    },
  ];
  const [passwordVisibility, setPasswordVisibility] = useState({
    password: false,
    confirmPassword: false,
  });
  const togglePasswordVisibility = (field: PasswordField) => {
    setPasswordVisibility((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };
  const salutation = [
    { value: "Mr.", label: "Mr" },
    { value: "Mrs.", label: "Mrs" },
    { value: "Miss.", label: "Miss" },
    { value: "Dr.", label: "Dr" },
  ];

  const gender = [
    { value: "M", label: "Male" },
    { value: "F", label: "Female" },
    { value: "O", label: "Other" },
  ];

  const statusChoose = [
    { value: "Active", label: "Active" },
    { value: "Inactive", label: "Inactive" },
  ];

  //create Form data to add new company start
  const initialFormData = {
    companyName: "",
    email: "",
    countryCode: "",
    phoneNumber: "",
    plan: "",
    password: "",
    confirmPassword: "",
    address1: "",
    address2: "",
    country: "",
    state: "",
    city: "",
    pincode: "",
    salutation: "",
    firstName: "",
    lastName: "",
    gender: "",
  };
  const [formData, setFormData] = useState(initialFormData);

  const handleInputChange = (e: any) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();

    // Form data to be sent to API
    const signature = localStorage.getItem("signature");

    const dataToSend = {
      signature: signature,
      companyName: formData.companyName,
      email: formData.email,
      phone_code: formData.countryCode,
      mobile_no: formData.phoneNumber,
      package_id: formData.plan,
      password: formData.password,
      address1: formData.address1,
      address2: formData.address2,
      country: formData.country,
      state: formData.state,
      city: formData.city,
      pincode: formData.pincode,
      salutation: formData.salutation,
      fname: formData.firstName,
      lname: formData.lastName,
      gender: formData.gender,
    };

    try {
      setIsLoading(true);
      const response = await api.post("userService/addNewCompany", dataToSend);
      setFormData(initialFormData);
      showBasicAlert(response.data.message[0].msg);
      //Send email to customer about login details
    } catch (error: any) {
      showBasicAlert(error.data.message[0].msg);
    } finally {
      await updateUI();
      setIsLoading(false); // hide loader after response
    }
  };

  //create Form data to add new company end

  //Update Company Start
  const handleSaveChanges = async () => {
    try {
      // Prepare the payload
      const body = {
        signature: signature,
        company_id: selectedCompanyEdit.key,
        company_name: selectedCompanyEdit.CompanyName,
        address1: selectedCompanyEdit.Address1,
        address2: selectedCompanyEdit.Address2,
        status: selectedCompanyEdit.Status,
      };
      try {
        setIsLoading(true);
        const response = await api.post("userService/editCompany", body);
        setFormData(initialFormData);
        showBasicAlert(response.data.message[0].msg);
      } catch (error: any) {
        showBasicAlert(error.data.message[0].msg);
      } finally {
        await updateUI();
        setIsLoading(false); // hide loader after response
      }
    } catch (error) {
      console.error("Error updating company details:", error);
      showBasicAlert("An error occurred. Please try again.");
    }
  };

  const UpgradePlan = async () => {
    try {
      const payload = selectedCompany;
      var body = {
        signature: signature,
        company_id: payload.key,
        package_id: payload.PackageId,
        billing_address1: formData.address1,
        billing_address2: formData.address2,
        city: formData.city,
        state: formData.state,
        country: formData.country,
        pincode: formData.pincode,
      };
      try {
        setIsLoading(true);
        const response = await api.post("userService/upgradePlan", body);
        setFormData(initialFormData);
        showBasicAlert(response.data.message[0].msg);
      } catch (error: any) {
        showBasicAlert(error.data.message[0].msg);
      } finally {
        await updateUI();
        setIsLoading(false); // hide loader after response
      }
    } catch (error) {
      setIsLoading(false); // hide loader after response
      console.error("Error updating company details:", error);
      showBasicAlert("An error occurred. Please try again.");
    }
  };
  //Update Company End
  const [deleteRecord, setDeleteRecord] = useState<{
    key: number;
    name: string;
  } | null>(null);
  //Delete Company Start

  const handleDelete = async () => {
    if (deleteRecord) {
      try {
        var company_id = deleteRecord.key;
        try {
          setIsLoading(true);
          const response = await api.post("userService/deleteCompany", {
            signature,
            company_id,
          });
          setFormData(initialFormData);
          showBasicAlert(response.data.message[0].msg);
        } catch (error: any) {
          showBasicAlert(error.data.message[0].msg);
        } finally {
          await updateUI();
          setIsLoading(false); // hide loader after response
        }
      } catch (error) {
        console.error("Error deleting item:", error);
        alert("Failed to delete item.");
      }
      setDeleteRecord(null);
    }
  };
  //Delete Compamny End

  //updateUI start
  const updateUI = async () => {
    const [companiesResponse] = await Promise.all([
      api.post("userService/getCompaniesData", { signature }),
    ]);
    setFilteredData(companiesResponse.data.data.data);
    setData(companiesResponse.data.data.data);
    setcompanyData(companiesResponse.data.data);
    setPlanName(companiesResponse.data.data.package_details);
    return;
  };
  //Update UI End

  //Generate random password
  const generateRandomPassword = () => {
    const length = 12; // Desired length of the password
    const charset =
      "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_+";
    let randomPassword = "";
    for (let i = 0; i < length; i++) {
      randomPassword += charset.charAt(
        Math.floor(Math.random() * charset.length)
      );
    }
    setFormData({ ...formData, password: randomPassword });
  };

  const emojiFromUPlus = (val?: string) => {
    if (!val) return "";
    // pick all U+XXXXXX tokens, fallback to split by non-hex
    const tokens =
      val.match(/U\+[0-9A-F]{4,6}/gi)?.map((t) => t.slice(2)) ||
      val
        .replace(/U\+/gi, "")
        .split(/[^0-9A-F]+/i)
        .filter(Boolean);

    return String.fromCodePoint(...tokens.map((h) => parseInt(h, 16)));
  };

  return (
    <>
      {isLoading && <Loader />}
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Companies</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.superAdminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Application</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Companies List
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="me-2 mb-2">
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    <i className="ti ti-file-export me-1" />
                    Export
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                        onClick={handleExportPDF}
                      >
                        <i className="ti ti-file-type-pdf me-1" />
                        Export as PDF
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                        onClick={handleExportExcel}
                      >
                        <i className="ti ti-file-type-xls me-1" />
                        Export as Excel{" "}
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="mb-2">
                <Link
                  to="#"
                  data-bs-toggle="modal"
                  data-bs-target="#add_company"
                  className="btn btn-primary d-flex align-items-center"
                >
                  <i className="ti ti-circle-plus me-2" />
                  Add Company
                </Link>
              </div>
              <div className="ms-2 head-icons">
                <CollapseHeader />
              </div>
            </div>
          </div>

          {/* /Breadcrumb */}
          <div className="row">
            {/* Total Companies */}
            <div className="col-lg-3 col-md-6 d-flex">
              <div className="card flex-fill">
                <div className="card-body d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center overflow-hidden">
                    <span className="avatar avatar-lg bg-primary flex-shrink-0">
                      <i className="ti ti-building fs-16" />
                    </span>
                    <div className="ms-2 overflow-hidden">
                      <p className="fs-12 fw-medium mb-1 text-truncate">
                        Total Companies
                      </p>
                      <h4>{companyData?.totalCompanies}</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* /Total Companies */}
            {/* Total Companies */}
            <div className="col-lg-3 col-md-6 d-flex">
              <div className="card flex-fill">
                <div className="card-body d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center overflow-hidden">
                    <span className="avatar avatar-lg bg-success flex-shrink-0">
                      <i className="ti ti-building fs-16" />
                    </span>
                    <div className="ms-2 overflow-hidden">
                      <p className="fs-12 fw-medium mb-1 text-truncate">
                        Active Companies
                      </p>
                      <h4>{companyData?.activeCompanies}</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* /Total Companies */}
            {/* Inactive Companies */}
            <div className="col-lg-3 col-md-6 d-flex">
              <div className="card flex-fill">
                <div className="card-body d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center overflow-hidden">
                    <span className="avatar avatar-lg bg-danger flex-shrink-0">
                      <i className="ti ti-building fs-16" />
                    </span>
                    <div className="ms-2 overflow-hidden">
                      <p className="fs-12 fw-medium mb-1 text-truncate">
                        Inactive Companies
                      </p>
                      <h4>{companyData?.inactiveCompanies}</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* /Inactive Companies */}
            {/* New Companies */}
            <div className="col-lg-3 col-md-6 d-flex">
              <div className="card flex-fill">
                <div className="card-body d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center overflow-hidden">
                    <span className="avatar avatar-lg bg-skyblue flex-shrink-0">
                      <i className="ti ti-map-pin-check fs-16" />
                    </span>
                    <div className="ms-2 overflow-hidden">
                      <p className="fs-12 fw-medium mb-1 text-truncate">
                        New Companies (In Week)
                      </p>
                      <h4>{companyData?.one_week_reg}</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* /New Companies*/}
            {/* Delete  Company */}
            <div className="col-lg-3 col-md-6 d-flex">
              <div className="card flex-fill">
                <div className="card-body d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center overflow-hidden">
                    <span className="avatar avatar-lg bg-skyblue flex-shrink-0">
                      <i className="ti ti-map-pin-check fs-16" />
                    </span>
                    <div className="ms-2 overflow-hidden">
                      <p className="fs-12 fw-medium mb-1 text-truncate">
                        Deleted Companies
                      </p>
                      <h4>{companyData?.deleteCompanies}</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* /Delete  Company */}
          </div>

          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5>Companies List</h5>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="me-3">
                  <div className="input-icon-end position-relative">
                    <PredefinedDateRanges onDateChange={handleDateChange} />
                    <span className="input-icon-addon">
                      <i className="ti ti-chevron-down" />
                    </span>
                  </div>
                </div>
                <div className="dropdown me-3">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    Plan {planFilter}
                  </Link>
                  <ul className="dropdown-menu dropdown-menu-end p-3">
                    {plan.map((plan: any) => (
                      <li key={plan.id}>
                        <Link
                          to="#"
                          className="dropdown-item rounded-1"
                          onClick={() => setPlanFilter(plan.name)}
                        >
                          {plan.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="dropdown me-3">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    Status {statusFilter}
                  </Link>
                  <ul className="dropdown-menu dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                        onClick={() => setStatusFilter("Active")}
                      >
                        Active
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                        onClick={() => setStatusFilter("Inactive")}
                      >
                        Inactive
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="dropdown me-3">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    Sort By: {sortBy}
                  </Link>
                  <ul className="dropdown-menu dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                        onClick={() => setSortBy("Recently Added")}
                      >
                        Recently Added
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                        onClick={() => setSortBy("Ascending")}
                      >
                        Ascending
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                        onClick={() => setSortBy("Descending")}
                      >
                        Descending
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                        onClick={() => setSortBy("Last Month")}
                      >
                        Last Month
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                        onClick={() => setSortBy("Last 7 Days")}
                      >
                        Last 7 Days
                      </Link>
                    </li>
                  </ul>
                </div>
                <div>
                  <button
                    type="button"
                    className="btn btn-success"
                    onClick={handleReset}
                  >
                    Reset
                  </button>
                </div>
              </div>
            </div>
            <div className="card-body p-0">
              <Table
                key={JSON.stringify(filteredData)}
                dataSource={filteredData}
                columns={columns}
                Selection={false}
              />
            </div>
          </div>
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2025 © {company_short_name}</p>
          <p>
            Designed & Developed By{" "}
            <Link to="#" className="text-primary">
              {company_short_name}
            </Link>
          </p>
        </div>
      </div>
      {/* /Page Wrapper */}
      {/* Add Company */}
      <div className="modal fade" id="add_company">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Add New Company</h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="modal-body pb-0">
                <div className="row">
                  {/* Company Name */}
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">
                        Company Name <span className="text-danger"> *</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="companyName"
                        value={formData.companyName}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>

                  {/* Email Address */}
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">Email Address</label>
                      <input
                        type="email"
                        className="form-control"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>

                  {/* Country Code */}
                  <div className="col-md-2">
                    <div className="mb-3">
                      <label className="form-label">
                        Country Code <span className="text-danger"> *</span>
                      </label>
                      <select
                        className="form-control"
                        name="countryCode"
                        value={formData.countryCode}
                        onChange={handleCountryCodeChange}
                      >
                        <option value="">Select</option>
                        {CountryCode.map((country, index) => (
                          <option key={index} value={country.phonecode}>
                            {country.ios2} {emojiFromUPlus(country.emojiU)}
                            {" +"}
                            {country.phonecode}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  {/* Phone Number */}
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="form-label">
                        Phone Number <span className="text-danger"> *</span>
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        name="phoneNumber"
                        value={formData.phoneNumber}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>

                  {/* Plan */}
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">
                        Package <span className="text-danger"> *</span>
                      </label>
                      <select
                        className="form-control"
                        name="plan"
                        value={formData.plan}
                        onChange={handleInputChange}
                      >
                        <option value="">Select</option>
                        {plan.map((plan) => (
                          <option key={plan.id} value={plan.id}>
                            {plan.name} - {plan.type_char}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  {/* Password */}
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">
                        Password <span className="text-danger"> *</span>
                      </label>
                      <div className="pass-group">
                        <input
                          type={
                            passwordVisibility.password ? "text" : "password"
                          }
                          className="pass-input form-control"
                          name="password"
                          value={formData.password}
                          onChange={handleInputChange}
                        />
                        <span
                          className={`ti toggle-passwords ${
                            passwordVisibility.password
                              ? "ti-eye"
                              : "ti-eye-off"
                          }`}
                          onClick={() => togglePasswordVisibility("password")}
                        ></span>
                      </div>
                      <button
                        type="button"
                        className="btn btn-secondary mt-2"
                        onClick={generateRandomPassword}
                      >
                        Generate Password
                      </button>
                    </div>
                  </div>

                  {/* Address */}
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">Address 1</label>
                      <input
                        type="text"
                        className="form-control"
                        name="address1"
                        value={formData.address1}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">Address 2</label>
                      <input
                        type="text"
                        className="form-control"
                        name="address2"
                        value={formData.address2}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>

                  {/* Country */}
                  <div className="col-md-3">
                    <div className="mb-3">
                      <label className="form-label">
                        Country <span className="text-danger"> *</span>
                      </label>
                      <select
                        className="form-control"
                        name="country"
                        value={formData.country}
                        onChange={handleCountryChange}
                      >
                        <option value="">Select Country</option>
                        {countries.map((country) => (
                          <option key={country.id} value={country.id}>
                            {country.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  {/* State */}
                  <div className="col-md-3">
                    <div className="mb-3">
                      <label className="form-label">
                        State <span className="text-danger"> *</span>
                      </label>
                      <select
                        className="form-control"
                        name="state"
                        value={formData.state}
                        onChange={handleStateChange}
                        disabled={!formData.country}
                      >
                        <option value="">Select State</option>
                        {states.map((state) => (
                          <option key={state.id} value={state.id}>
                            {state.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  {/* City */}
                  <div className="col-md-3">
                    <div className="mb-3">
                      <label className="form-label">
                        City <span className="text-danger"> *</span>
                      </label>
                      <select
                        className="form-control"
                        name="city"
                        value={formData.city}
                        onChange={handleCityChange}
                        disabled={!formData.state}
                      >
                        <option value="">Select City</option>
                        {cities.map((city) => (
                          <option key={city.id} value={city.id}>
                            {city.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  {/* Pincode */}
                  <div className="col-md-3">
                    <div className="mb-3">
                      <label className="form-label">Pincode</label>
                      <input
                        type="text"
                        className="form-control"
                        name="pincode"
                        value={formData.pincode}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>

                  <h4 className="modal-title">Admin Details</h4>

                  {/* Salutation */}
                  <div className="col-md-2">
                    <div className="mb-3">
                      <label className="form-label">
                        Salutation <span className="text-danger"> *</span>
                      </label>
                      <select
                        className="form-control"
                        name="salutation"
                        value={formData.salutation}
                        onChange={handleInputChange}
                      >
                        <option value="">Select</option>
                        {salutation.map((data) => (
                          <option key={data.value} value={data.value}>
                            {data.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  {/* First Name */}
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="form-label">
                        First Name <span className="text-danger"> *</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="firstName"
                        value={formData.firstName}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>

                  {/* Last Name */}
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="form-label">Last Name</label>
                      <input
                        type="text"
                        className="form-control"
                        name="lastName"
                        value={formData.lastName}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>

                  {/* Gender */}
                  <div className="col-md-2">
                    <div className="mb-3">
                      <label className="form-label">
                        Gender <span className="text-danger"> *</span>
                      </label>
                      <select
                        className="form-control"
                        name="gender"
                        value={formData.gender}
                        onChange={handleInputChange}
                      >
                        <option value="">Select</option>
                        {gender.map((data) => (
                          <option key={data.value} value={data.value}>
                            {data.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-light me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button type="submit" className="btn btn-primary">
                  Add Company
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* /Add Company */}

      {/* Company Detail */}
      <div
        className="modal fade"
        id="company_detail"
        aria-labelledby="company_detailLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="company_detailLabel">
                Company Detail
              </h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              {selectedCompany && (
                <div className="p-3">
                  <div className="d-flex justify-content-between align-items-center rounded bg-light p-3">
                    <div className="file-name-icon d-flex align-items-center">
                      <Link
                        to="#"
                        className="avatar avatar-md border rounded-circle flex-shrink-0 me-2"
                      >
                        <ImageWithBasePath
                          src={`${
                            selectedCompany.Image ||
                            "assets/img/users/user-01.jpg"
                          }`}
                          className="img-fluid"
                          alt="img"
                        />
                      </Link>
                      <div>
                        <p className="text-gray-9 fw-medium mb-0">
                          {selectedCompany.CompanyName}
                        </p>
                        <p>{selectedCompany.Email}</p>
                      </div>
                    </div>

                    <span
                      className={`badge ${
                        selectedCompany.Status === "Active"
                          ? "badge-success"
                          : "badge-danger"
                      } d-inline-flex align-items-center badge-xs`}
                    >
                      <i className="ti ti-point-filled" />
                      {selectedCompany.Status}
                    </span>
                  </div>

                  <div className="p-3">
                    <p className="text-gray-9 fw-medium">Basic Details</p>
                    <div className="pb-1 border-bottom mb-4">
                      <div className="row align-items-center">
                        <div className="col-md-4">
                          <div className="mb-3">
                            <p className="fs-12 mb-0">Phone Number</p>
                            <p className="text-gray-9">
                              {selectedCompany.Mobile_No}
                            </p>
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="mb-3">
                            <p className="fs-12 mb-0">Address</p>
                            <p className="text-gray-9">
                              {selectedCompany.Address}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="mb-3">
                          <p className="fs-12 mb-0">Registered Date</p>
                          <p className="text-gray-9">
                            {selectedCompany.CreatedDate}
                          </p>
                        </div>
                      </div>
                    </div>
                    <p className="text-gray-9 fw-medium">Admin Details</p>
                    <div className="pb-1 border-bottom mb-4">
                      <div className="row align-items-center">
                        <div className="col-md-4">
                          <div className="mb-3">
                            <p className="fs-12 mb-0">Name</p>
                            <p className="text-gray-9">
                              {selectedCompany.FullName}
                            </p>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="mb-3">
                            <p className="fs-12 mb-0">Address</p>
                            <p className="text-gray-9">
                              {selectedCompany.Address}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <p className="text-gray-9 fw-medium">Plan Details</p>
                    <div>
                      <div className="row align-items-center">
                        <div className="col-md-4">
                          <div className="mb-3">
                            <p className="fs-12 mb-0">Plan Name</p>
                            <p className="text-gray-9">
                              {selectedCompany.Plan}
                            </p>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="mb-3">
                            <p className="fs-12 mb-0">Plan Type</p>
                            <p className="text-gray-9">
                              {selectedCompany.Type}
                            </p>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="mb-3">
                            <p className="fs-12 mb-0">Price</p>
                            <p className="text-gray-9">
                              {selectedCompany.countryCurrency}{" "}
                              {selectedCompany.Price}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="row align-items-center">
                        <div className="col-md-4">
                          <div className="mb-3">
                            <p className="fs-12 mb-0">Purchase Date</p>
                            <p className="text-gray-9">
                              {selectedCompany.PurchaseDate}
                            </p>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="mb-3">
                            <p className="fs-12 mb-0">Expiring On</p>
                            <p className="text-gray-9">
                              {selectedCompany.ExpireDate}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* /Company Detail */}

      {/* Edit Company */}
      <div
        className="modal fade"
        id="edit_company"
        aria-labelledby="company_edit"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="company_edit">
                Edit Company
              </h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form>
              <div className="modal-body pb-0">
                {selectedCompanyEdit && (
                  <div className="row">
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">
                          Name <span className="text-danger"> *</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={selectedCompanyEdit.CompanyName || ""}
                          onChange={(e) =>
                            setSelectedCompanyEdit((prev: any) => ({
                              ...prev,
                              CompanyName: e.target.value,
                            }))
                          }
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Email Address</label>
                        <input
                          type="email"
                          className="form-control"
                          value={selectedCompanyEdit.Email || ""}
                          readOnly
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">
                          Mobile Number <span className="text-danger"> *</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={selectedCompanyEdit.Mobile_No || ""}
                          disabled
                        />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="form-label">Address 1</label>
                        <input
                          type="text"
                          className="form-control"
                          value={selectedCompanyEdit.Address1 || ""}
                          onChange={(e) =>
                            setSelectedCompanyEdit((prev: any) => ({
                              ...prev,
                              Address1: e.target.value,
                            }))
                          }
                        />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="form-label">Address 2</label>
                        <input
                          type="text"
                          className="form-control"
                          value={selectedCompanyEdit.Address2 || ""}
                          onChange={(e) =>
                            setSelectedCompanyEdit((prev: any) => ({
                              ...prev,
                              Address2: e.target.value,
                            }))
                          }
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="mb-3">
                        <label className="form-label">Status</label>
                        <CommonSelect
                          className="select"
                          options={statusChoose}
                          defaultValue={{
                            value: selectedCompanyEdit.Status,
                            label: selectedCompanyEdit.Status,
                          }}
                          onChange={(selectedOption: any) =>
                            setSelectedCompanyEdit((prev: any) => ({
                              ...prev,
                              Status: selectedOption.value,
                            }))
                          }
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-light me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  data-bs-dismiss="modal"
                  className="btn btn-primary"
                  onClick={handleSaveChanges}
                >
                  Save Changes
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* /Edit Company */}

      {/* Upgrade Information */}
      <div className="modal fade" id="upgrade_info">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Upgrade Package</h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            {selectedCompany && (
              <div>
                <div className="p-3 mb-1">
                  <div className="rounded bg-light p-3">
                    <h5 className="mb-3">Current Plan Details</h5>
                    <div className="row align-items-center">
                      <div className="col-md-4">
                        <div className="mb-3">
                          <p className="fs-12 mb-0">Company Name</p>
                          <p className="text-gray-9">
                            {selectedCompany.CompanyName}
                          </p>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="mb-3">
                          <p className="fs-12 mb-0">Plan Name</p>
                          <p className="text-gray-9">{selectedCompany.Plan}</p>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="mb-3">
                          <p className="fs-12 mb-0">Plan Type</p>
                          <p className="text-gray-9">{selectedCompany.Type}</p>
                        </div>
                      </div>
                    </div>
                    <div className="row align-items-center">
                      <div className="col-md-4">
                        <div className="mb-3">
                          <p className="fs-12 mb-0">Price</p>
                          <p className="text-gray-9">
                            {selectedCompany.countryCurrency}{" "}
                            {selectedCompany.Price}
                          </p>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="mb-3">
                          <p className="fs-12 mb-0">Purchase Date</p>
                          <p className="text-gray-9">
                            {selectedCompany.PurchaseDate}
                          </p>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="mb-3">
                          <p className="fs-12 mb-0">Expiring On</p>
                          <p className="text-gray-9">
                            {selectedCompany.ExpireDate}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <form action="companies.html">
                  <div className="modal-body pb-0">
                    <h5 className="mb-4">Change Plan</h5>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="mb-3 ">
                          <label className="form-label">
                            Plan Name <span className="text-danger">*</span>
                          </label>
                          <CommonSelect
                            className="select"
                            options={planName}
                            onChange={(selectedOption: any) =>
                              setSelectedCompany((prev: any) => ({
                                ...prev,
                                PackageId: selectedOption.value,
                              }))
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="modal-body pb-0">
                    <h5 className="mb-4">Billing Details</h5>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="mb-3">
                          <label className="form-label">Address 1</label>
                          <input
                            type="text"
                            className="form-control"
                            name="address1"
                            value={formData.address1}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="mb-3">
                          <label className="form-label">Address 2</label>
                          <input
                            type="text"
                            className="form-control"
                            name="address2"
                            value={formData.address2}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                      {/* Country */}
                      <div className="col-md-3">
                        <div className="mb-3">
                          <label className="form-label">
                            Country <span className="text-danger"> *</span>
                          </label>
                          <select
                            className="form-control"
                            name="country"
                            value={formData.country}
                            onChange={handleCountryChange}
                          >
                            <option value="">Select Country</option>
                            {countries.map((country) => (
                              <option key={country.id} value={country.id}>
                                {country.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      {/* State */}
                      <div className="col-md-3">
                        <div className="mb-3">
                          <label className="form-label">
                            State <span className="text-danger"> *</span>
                          </label>
                          <select
                            className="form-control"
                            name="state"
                            value={formData.state}
                            onChange={handleStateChange}
                            disabled={!formData.country}
                          >
                            <option value="">Select State</option>
                            {states.map((state) => (
                              <option key={state.id} value={state.id}>
                                {state.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      {/* City */}
                      <div className="col-md-3">
                        <div className="mb-3">
                          <label className="form-label">
                            City <span className="text-danger"> *</span>
                          </label>
                          <select
                            className="form-control"
                            name="city"
                            value={formData.city}
                            onChange={handleCityChange}
                            disabled={!formData.state}
                          >
                            <option value="">Select City</option>
                            {cities.map((city) => (
                              <option key={city.id} value={city.id}>
                                {city.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      {/* Pincode */}
                      <div className="col-md-3">
                        <div className="mb-3">
                          <label className="form-label">Pincode</label>
                          <input
                            type="text"
                            className="form-control"
                            name="pincode"
                            value={formData.pincode}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-light me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      data-bs-dismiss="modal"
                      className="btn btn-primary"
                      onClick={UpgradePlan}
                    >
                      Save Changes
                    </button>
                  </div>
                </form>
              </div>
            )}
          </div>
        </div>
      </div>
      {/* /Upgrade Information */}

      <DeleteModal
        modalId="delete_modal"
        onDelete={handleDelete}
        title="Delete Item"
        message="Are you sure you want to delete this item? This action cannot be undone."
      />
    </>
  );
};

export default Companies;
